export default "__VITE_ASSET__BwQFrPLQ__"